import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M32 4C16.5 4 4 15.2 4 29c0 7.6 3.8 14.4 9.8 19L11 60l13.6-7.3c2.3.5 4.8.8 7.4.8 15.5 0 28-11.2 28-25S47.5 4 32 4z" fill="#2563EB" />
    <path d="M20 30l8 8 16-17" fill="none" stroke="#fff" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="50" cy="12" r="7" fill="#10B981" />
  </svg>
);

export function Logo({ to = "/", light = false, small = false }) {
  return (
    <Link to={to} className="flex items-center gap-2" data-testid="brand-logo">
      <LogoMark className={small ? "h-7 w-7" : "h-9 w-9"} />
      <span className={`font-extrabold tracking-tight ${small ? "text-lg" : "text-xl"}`}>
        <span className={light ? "text-white" : "text-[#0E1726]"}>SURVEY</span>
        <span className="text-[#10B981]">KARO</span>
      </span>
    </Link>
  );
}
